import {
  type DropResult,
  DragDropContext,
  Droppable,
  Draggable,
  type DraggableProvided,
  type DraggableStateSnapshot,
} from 'react-beautiful-dnd'
import { type ReactNode } from 'react'

type IDragEndDropSectionProps<T> = {
  droppableId: string
  onDragEnd?: (result: DropResult) => void
  items: T[]
  renderItem: (item: T, provided: DraggableProvided, snapshot: DraggableStateSnapshot) => ReactNode
}

export const DragEndDropSection = <T extends { key: string }>({
  droppableId,
  onDragEnd,
  items,
  renderItem,
}: IDragEndDropSectionProps<T>) => {
  return (
    <DragDropContext
      onDragEnd={(result) => {
        onDragEnd?.(result)
      }}
    >
      <Droppable droppableId={droppableId}>
        {(provided) => {
          return (
            <div ref={provided.innerRef} {...provided.droppableProps}>
              {items.map((item, index) => {
                return (
                  <Draggable key={item.key} draggableId={item.key} index={index}>
                    {(provided, snapshot) => {
                      return (
                        <div ref={provided.innerRef} {...provided.draggableProps}>
                          {renderItem(item, provided, snapshot)}
                        </div>
                      )
                    }}
                  </Draggable>
                )
              })}
              {provided.placeholder}
            </div>
          )
        }}
      </Droppable>
    </DragDropContext>
  )
}
